import React from "react";

function Forgejo({ small }) {
  return (
    <svg
      className="inline"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 212 212"
      width={small ? "16px" : "24px"}
      height={small ? "16px" : "24px"}
    >
      <g transform="translate(6,6)" fill="none" stroke="currentColor">
        <path d="M58 168 v-98 a50 50 0 0 1 50-50 h20" strokeWidth="25" />
        <path d="M58 168 v-30 a50 50 0 0 1 50-50 h20" strokeWidth="25" />
        <circle cx="142" cy="20" r="18" strokeWidth="15" />
        <circle cx="142" cy="88" r="18" strokeWidth="15" />
        <circle cx="58" cy="180" r="18" strokeWidth="15" />
      </g>
    </svg>
  );
}

export default Forgejo;
